import { Component, OnChanges, Input } from '@angular/core';

import { MonitoringResultGraph } from '@classes/monitoring/monitoring-result-graph';

@Component({
  selector: 'app-monitoring-results-graph',
  templateUrl: './monitoring-results-graph.component.html',
  styleUrls: ['./monitoring-results-graph.component.scss']
})
export class MonitoringResultsGraphComponent implements OnChanges {

    @Input() graph: MonitoringResultGraph;

    isEmpty = true;

    constructor () {}

    ngOnChanges (): void {
        this.isEmpty = !this.graph || !this.graph.datas
            || !this.graph.datas.some(data => data.value != 0);
    }

}
